<img
  [src]="src"
  [attr.width]="width ?? defaults.width"
  [attr.height]="height ?? defaults.height"
  [alt]="alt ?? defaults.alt"
/>
